import KeyIcon from '@mui/icons-material/Key'
import { Box, Button, Container, InputAdornment, InputLabel, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import '../../Style.css'
import { Formik } from 'formik'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import VerificationInput from 'react-verification-input'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import Input from '../../shared/Input'
import { changePassword, getError, getMessage, setError, setMessage } from '../../store/auth'
interface FormValues4 {
  confirmCode: string
  password: string
}

const initialValues4: FormValues4 = {
  confirmCode: '',
  password: '',
}

const validationSchema4 = Yup.object().shape({
  confirmCode: Yup.string()
    .min(6, 'کدتایید حداقل باید شامل 6 کاراکتر باشد')
    .required('ورود کد تایید الزامی است')
    .label('confirmCode'),
  password: Yup.string()
    .min(4, 'رمز عبور حداقل باید شامل 4 کاراکتر باشد')
    .required('ورود رمز عبور جدید الزامی است')
    .label('password'),
})
interface FormValues {
  confirmationCode: string
  password: string
}

const initialValues: FormValues = { confirmationCode: '', password: '' }

const validationSchema = Yup.object().shape({
  confirmationCode: Yup.string().min(4).required('Password is required'),
  password: Yup.string().min(4).required('Password is required'),
})

const ChangePasswordProfile: React.FC = () => {
  const { t } = useTranslation()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<Dispatch<any>>()
  const handleSubmit = (values: any) => {
    dispatch(
      changePassword({
        phoneNumber: location.state.phoneNumber,
        confirmationCode: values.confirmCode,
        password: values.password,
      }),
    )
  }

  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    navigate(`/${routes.PROFILE}`)
  }, [message])

  return (
    <Container fixed maxWidth='xs' sx={{ direction: 'ltr' }}>
      <Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
        <img alt='Logo' src='/images/TinyLogo.png' />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          mt: 23,
        }}
      >
        <Box sx={{ mb: 2, ml: 1, direction: 'rtl' }}>
          <Typography sx={{ color: 'grey.700' }} variant='h5'>
            {t('screens.profile.changePassword_title_placeholder')}
          </Typography>
        </Box>
        {/* <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <Box display='flex' justifyContent='center'>
            <VerificationInput
              inputProps={{ type: 'tel' }}
              onChange={(e) => }
              validChars='0-9'
            />

          </Box>
          
          <FormField
            name='confirmationCode'
            placeholder={t('screens.profile.confirmationCode_input_placeholder')}
            startAdornment={
              <InputAdornment position='start'>
                <KeyIcon />
              </InputAdornment>
            }
          />
          <FormField
            name='password'
            placeholder={t('screens.profile.password_input_placeholder')}
            startAdornment={
              <InputAdornment position='start'>
                <KeyIcon />
              </InputAdornment>
            }
          />

          <SubmitButton title={t('screens.profile.submit_button_placeholder')} />
        </Form> */}
        <Formik
          enableReinitialize={true}
          initialValues={initialValues4}
          onSubmit={handleSubmit}
          validationSchema={validationSchema4}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,

            /* and other goodies */
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <InputLabel id='demo-simple-select-label' sx={{ direction: 'rtl' }}>
                  کد تایید ارسالی:
                </InputLabel>
                <Box display='flex' justifyContent='center' sx={{ borderRadius: 1, p: 2 }}>
                  <VerificationInput
                    classNames={{
                      container: 'container',
                      character: 'character',
                      characterInactive: 'character--inactive',
                      characterSelected: 'character--selected',
                    }}
                    inputProps={{ type: 'tel' }}
                    onChange={(e) => {
                      setFieldValue('confirmCode', e)
                    }}
                    validChars='0-9'
                  />
                </Box>
                <div style={{ color: 'red', fontSize: '12px', direction: 'rtl', margin: '2px' }}>
                  {errors.confirmCode}
                </div>
                <InputLabel id='demo-simple-select-label' sx={{ direction: 'rtl' }}>
                  رمزعبور جدید:
                </InputLabel>

                <Input
                  autoComplete='off'
                  fullWidth
                  name='password'
                  onBlur={handleBlur}
                  onChange={(e: any) => handleChange(e)}
                  startAdornment={
                    <InputAdornment position='start'>
                      <KeyIcon />
                    </InputAdornment>
                  }
                  value={values.password}
                />
                <div style={{ color: 'red', fontSize: '12px', direction: 'rtl', margin: '1px' }}>
                  {errors.password}
                </div>

                <Button
                  fullWidth
                  onClick={(e) => {
                    handleSubmit()
                  }}
                  sx={{ mt: 1 }}
                  variant='contained'
                >
                  ارسال
                </Button>
              </form>
            </>
          )}
        </Formik>
      </Box>
    </Container>
  )
}

export default ChangePasswordProfile
